module.exports = __webpack_public_path__ + "img/b1.670c385a.png";